import 'css-chunksrc/client/common/projectsSelection/zones/styles.scss';export default {
  "header": "_header_1y0uy_1",
  "title": "_title_1y0uy_10",
  "loader": "_loader_1y0uy_17"
};